import React from 'react'
import { Link } from 'react-router-dom'

const Notfound = () => {
  return (
    <>
    <div className='my-5 text-center'></div>
    <h5 className='display-5 pt-5 text-center'>
        Page Not Found
    </h5>
            <Link className="" style={{textDecoration:'none'}} to="/">
                  <button
                  style={{display:'flex',margin:'auto'}}
                    className="my-5 sign-up-button align-items-center btn btn-dark"
                    // style={{ width: "95px" }}
                  >
                    
                    Return to Home
                  </button>
                </Link>
    </>
  )
}

export default Notfound
